export default __webpack_public_path__ + "static/g2three-3d27f40f3dbf6eba70bf15c096e36e5c.jpg";